import { Link } from 'react-router-dom';
import type { NavItem } from '@/app/nav';

interface SidebarSubItemListProps {
    items: NonNullable<NavItem['subItems']>;
    isActive: (path: string) => boolean;
    className?: string;
}

function Badge({ label, active }: { label: string; active: boolean }) {
    return (
        <span
            className={`ml-auto ${active ? 'menu-dropdown-badge-active' : 'menu-dropdown-badge-inactive'} menu-dropdown-badge`}
        >
            {label}
        </span>
    );
}

/** A parent item's sub-links with their badges, shared by the inline panel and the rail flyout. */
export default function SidebarSubItemList({ items, isActive, className = '' }: SidebarSubItemListProps) {
    return (
        <ul className={className}>
            {items.map((subItem) => {
                const active = isActive(subItem.path);
                return (
                    <li key={subItem.name}>
                        <Link
                            to={subItem.path}
                            className={`menu-dropdown-item ${
                                active ? 'menu-dropdown-item-active' : 'menu-dropdown-item-inactive'
                            }`}
                        >
                            {subItem.name}
                            <span className="flex items-center gap-1 ml-auto">
                                {subItem.new && <Badge label="new" active={active} />}
                                {subItem.pro && <Badge label="pro" active={active} />}
                            </span>
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
}
